export const unsafeConvertLegacyInsuranceLineItemToAdjustment = (lineItem) => {
    if (!lineItem.metadata || lineItem.metadata.type !== 'PARTNER_OPTION') {
        throw new Error('convertLegacyInsuranceLineItemToAdjustment can only be used for legacy insurance line items');
    }
    return {
        id: lineItem.id,
        amount: lineItem.unit_price,
        metadata: {
            type: 'INSURANCE'
        },
        discount: {
            code: 'LegacyInsurance'
        }
    };
};
